module.exports = __webpack_public_path__ + "img/pos1-bg.98742fbc.jpg";